import { getRequest, postRequest } from "../../Services/AxiosConfiguration";
import { useSelector } from "react-redux";

import { BlobServiceClient } from "@azure/storage-blob";
import {
  API_BASE_URL,
  BASE_FILE_UPLOAD_API,
  CREATE_NEW_FOLDER_API,
  CREATE_NEW_SCENARIO_API,
  GET_SENARIO_NUMBER_API,
  UPLOAD_DETAILS_API,
  DOWNLOAD_TEMPLATE_API,
  DOWNLOAD_COG_TEMPLATE_API,
  DOWNLOAD_COG_RERUN_TEMPLATE_API,
  DOWNLOAD_TEMPLATE_API_MEDIUM,
  DOWNLOAD_RERUN_ST_HC_TEMPLATE_API,
  DOWNLOAD_RERUN_ST_NT_TEMPLATE_API,
  DOWNLOAD_RERUN_MT_HC_TEMPLATE_API,
  DOWNLOAD_RERUN_MT_NT_TEMPLATE_API,
  GET_AZURE_MAP_DATA,
  NUTRITION_GET_AZURE_MAP_DATA,
  CGO_POTENTIAL_DATA_DOWNLOAD,
  LONG_QUESTIONARE_DOWNLOAD_API,
  DOWNLOAD_LT_TEMPLATE,
  DOWNLOAD_LT_RERUN_TEMPLATE,
  LONG_EXCEL_FILE_UPLOAD_API,
  UPLOAD_LONGTERM_FILE_API,
  UPLOAD_LONGTERM_SINGLE_FILE_API,
  UPLOAD_SHORTTERM_FILE_API,
  UPLOAD_SHORTTERM_SINGLE_FILE_API,
  UPLOAD_MEDIUMTERM_FILE_API,
  UPDATE_FOLDER_STATUS,
  UPLOAD_MEDIUMTERM_SINGLE_FILE_API,
  UPLOAD_COG_SINGLE_FILE_API,
} from "../../Utils/Config";
import {
  GET_INPUT_DATA,
  CREATE_FOLDER,
  CREATED_FOLDER,
  GO_BACK,
  SCENARIAO_DATA_NEXT,
  SCENARIAO_BACK,
  UPLOAD_SCENARIO_DATA,
  UPLOAD_BASE_LINE_DATA,
  CLOSE_MODAL,
  BASE_LINE_UPLOADING_DONE,
  CLOSE_CREATED_FOLDER,
  UPLOAD_MASTER_FILE_START,
  UPLOAD_MASTER_FILE_SUCCESS,
  UPLOAD_MASTER_FILE_ERROR,
  INPUT_FOLDER_NAME,
  UPLOAD_BASE_LINE_ERROR,
  UPLOAD_BASE_LINE_START,
  UPLOAD_BASE_LINE_SUCCESS,
  BASE_LINE_UPLOADER,
  CLOSE_DONE_POPUP,
  CREATE_NEW_FOLDER_START,
  CREATE_NEW_FOLDER_SUCCESS,
  SELECTED_UPLOAD_FOLDER_ID,
  SELECTED_UPLOAD_SCENARIO_ID,
  CREATE_NEW_FOLDER_ERROR,
  CREATE_NEW_SCENARIO_ERROR,
  CREATE_NEW_SCENARIO_START,
  CREATE_NEW_SCENARIO_SUCCESS,
  DISPLAY_FOLDER_LIST,
  DISPLAY_FOLDER_LIST_SUCCESS,
  DISPLAY_FOLDER_LIST_ERROR,
  UPLOAD_SCENARIO_LINE_START,
  UPLOAD_SCENARIO_LINE_ERROR,
  UPLOAD_SCENARIO_LINE_SUCCESS,
  CLOSE_ERROR_POPUP,
  OPEN_ERROR_POPUP,
  VIEW_PRODUCT_TABLE,
  VIEW_PRODUCT_TABLE_SUCCESS,
  VIEW_PRODUCT_TABLE_ERROR,
  EDIT_PRODUCT_TABLE,
  EDIT_PRODUCT_TABLE_SUCCESS,
  EDIT_PRODUCT_TABLE_ERROR,
  SELECTED_FOLDER_LIST,
  SELECTED_FOLDER_LIST_ERROR,
  SELECTED_FOLDER_LIST_SUCCESS,
  SELECTED_UPLOAD_FOLDER_LIST_SUCCESS,
  CLOSE_SELECTED_FOLDER,
  DISPLAY_SCENARIO_LIST,
  DISPLAY_SCENARIO_LIST_ERROR,
  DISPLAY_SCENARIO_LIST_SUCCESS,
  SELECTED_SCENARIO_LIST,
  SELECTED_TIME_PERIOD_LIST,
  SELECTED_SCENARIO_LIST_ERROR,
  SELECTED_SCENARIO_LIST_SUCCESS,
  SELECTED_CATEGORY_LIST_ERROR,
  SELECTED_CATEGORY_LIST_SUCCESS,
  DASHBOARD_SUMMARY_COST,
  DASHBOARD_SUMMARY_COST_SUCCESS,
  DASHBOARD_SUMMARY_COST_ERROR,
  NUTRITION_DASHBOARD_SUMMARY_COST,
  NUTRITION_DASHBOARD_SUMMARY_COST_SUCCESS,
  NUTRITION_DASHBOARD_SUMMARY_COST_ERROR,
  SELECTED_USECASE_LIST_SUCCESS,
  SELECTED_USECASE_LIST_ERROR,
  GET_SCENARIO_NUMBER_START,
  GET_SCENARIO_NUMBER_SUCCESS,
  GET_SCENARIO_NUMBER_ERROR,
  IS_FOLDER_EXISTED,
  IS_SCENARIO_EXISTED,
  IS_DUPLICATE_SCENARIO_CREATED,
  CLOSE_ERROR_OR_WARNING_POPUP,
  OPEN_ERROR_OR_WARNING_POPUP,
  ENABLE_EDIT,
  DISABLE_EDIT,
  FILE_UPLOAD_STATUS,
  CREATE_FOLDER_SCENARIO_ERROR,
  EDIT_SCENARIO_POPUP_FLAG,
  SET_PROCESSING_PACKAGING_PL,
  SET_SOURCE_BE_PART_OF_OPTIMIZATION,
  SET_PROCESSING_PACKAGING_PLANT_ADD_MINOR,
  LOGIN_USER_DATA,
  API_USER_DATA,
} from "./ActionType";
import FileSaver from "file-saver";
import axios from "axios";
import { ActivateOrDeactivateFolder } from "../../Services/FolderService";

export const inputData = () => ({
  type: GET_INPUT_DATA,
});

export const createFolder = () => ({
  type: CREATE_FOLDER,
});
export const createdFolder = () => ({
  type: CREATED_FOLDER,
});

export const isFolderExisted = (data: any) => ({
  type: IS_FOLDER_EXISTED,
  data,
});

export const isScenarioExisted = (data: any) => ({
  type: IS_SCENARIO_EXISTED,
  data,
});

export const createrFolderOrScenarioError = (data: any) => ({
  type: CREATE_FOLDER_SCENARIO_ERROR,
  data,
});

export const goBack = () => ({
  type: GO_BACK,
});

export const scenarioaDataNext = () => ({
  type: SCENARIAO_DATA_NEXT,
});

export const scenarioaBack = () => ({
  type: SCENARIAO_BACK,
});

export const uploadScenarioData = (data: any) => ({
  type: UPLOAD_SCENARIO_DATA,
  data,
});

export const uploadBaseLineData = () => ({
  type: UPLOAD_BASE_LINE_DATA,
});

export const closeModal = () => ({
  type: CLOSE_MODAL,
});

export const baseLineUploadingDone = () => ({
  type: BASE_LINE_UPLOADING_DONE,
});

export const closecreatedFolder = () => ({
  type: CLOSE_CREATED_FOLDER,
});

export const closeselectedFolder = () => ({
  type: CLOSE_SELECTED_FOLDER,
});

export const cloaseDonePopup = () => ({
  type: CLOSE_DONE_POPUP,
});

export const openDonePopup = (data: any) => ({
  type: "OPEN_DONE_POPUP",
  data,
});
export const closeErrorDialog = () => ({
  type: CLOSE_ERROR_POPUP,
});
export const openErrorDialog = (error: any) => ({
  type: OPEN_ERROR_POPUP,
  error,
});

export const closeErrorOrWarningDialog = () => ({
  type: CLOSE_ERROR_OR_WARNING_POPUP,
});
export const openErrorOrWarningDialog = (error: any) => ({
  type: OPEN_ERROR_OR_WARNING_POPUP,
  error,
});

export const isDuplicateScenarioCreated = (error: any) => ({
  type: IS_DUPLICATE_SCENARIO_CREATED,
  error,
});

//Get Scenario Number
export const getScenarioNumberStart = () => ({
  type: GET_SCENARIO_NUMBER_START,
});

export const getScenarioNumberSuccess = (data: any) => ({
  type: GET_SCENARIO_NUMBER_SUCCESS,
  data,
});

export const getScenarioNumberError = (error: any) => ({
  type: GET_SCENARIO_NUMBER_ERROR,
  error,
});

//Upload MasterFile Actions
export const uploadMasterFileStart = () => ({
  type: UPLOAD_MASTER_FILE_START,
});

export const uploadMasterFileSuccess = (data: any) => ({
  type: UPLOAD_MASTER_FILE_SUCCESS,
  data,
});

export const uploadMasterFileError = (error: any) => ({
  type: UPLOAD_MASTER_FILE_ERROR,
  error,
});

export const onInitGetScenarioNumber = () => {
  return (dispatch: any) => {
    const urls = API_BASE_URL + GET_SENARIO_NUMBER_API;
    const header = {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    };
    getRequest(urls, {}, header)
      .then((response) => {
        dispatch(getScenarioNumberSuccess(response.data));
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(getScenarioNumberError(error));
      });
  };
};

export const getAzureMapData = (
  usecaseId: number,
  category_Id: number,
  folderId: number,
  scenarioId: number,
  timePeriod: string,
) => {
  return (dispatch: any) => {
    const urls = API_BASE_URL + GET_AZURE_MAP_DATA;
    const header = {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    };
    getRequest(
      urls,
      {
        usecaseId: usecaseId,
        category_Id: category_Id,
        folder_id: folderId,
        scenarioId: scenarioId,
        timeperiod: timePeriod,
      },
      header,
    )
      .then((response) => {
        //dispatch(getScenarioNumberSuccess(response.data));
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        // dispatch(getScenarioNumberError(error));
      });
  };
};

export const nutritionGetAzureMapData = (
  usecaseId: number,
  category_Id: number,
  folderId: number,
  scenarioId: number,
  timePeriod: string,
) => {
  return (dispatch: any) => {
    const urls = API_BASE_URL + NUTRITION_GET_AZURE_MAP_DATA;
    const header = {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    };
    getRequest(
      urls,
      {
        usecaseId: usecaseId,
        category_Id: category_Id,
        folder_id: folderId,
        scenarioId: scenarioId,
        timeperiod: timePeriod,
      },
      header,
    )
      .then((response) => {
        //dispatch(getScenarioNumberSuccess(response.data));
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        // dispatch(getScenarioNumberError(error));
      });
  };
};

const saveUploadFile = (dispatch: any, data: any) => {
  console.log(typeof data[0]["FileType"], "dataatatatta");
  const urls = API_BASE_URL + UPLOAD_DETAILS_API;
  const header = {
    accept: "application/json",
    "Content-Type": "application/json",
  };
  postRequest(urls, data, header, {})
    .then((response) => {
      if (response.status === 200) {
        if (typeof data[0]["FileType"] !== "number") {
          dispatch(uploadMasterFileSuccess("Uploaded Successfully"));
          dispatch(
            openDonePopup(response.data?.message || "Uploaded Successfully"),
          );
        }
      }
    })
    .catch((error) => {
      const payload = normalizeError(error);
      dispatch(openErrorDialog(payload)); // UI should read payload.message
      dispatch(uploadMasterFileError(payload));
    });
};

const saveLongTermUploadFile = (data: any) => {
  //dispatch(uploadMasterFileStart());
  //const urls = API_BASE_URL + MASTER_FILE_UPLOAD_API;

  const urls = API_BASE_URL + LONG_EXCEL_FILE_UPLOAD_API;
  const header = {
    accept: "application/json",
    "Content-Type": "application/json",
  };
  postRequest(urls, data, header, {})
    .then((response) => {
      if (response.status === 200) {
        //Success block
        //dispatch(uploadMasterFileSuccess(response.data));
      }
    })
    .catch((error) => {
      // dispatch(openErrorDialog(error));
      // dispatch(uploadMasterFileError(error));
      //Error block
    });
};

const getFileName = (
  fileType: string,
  fileName: string,
  intitialValues: any,
): string => {
  if (intitialValues.usecase === 1) {
    let targetFileName = "";
    let userId = 1;
    const resultFileName = fileName.substring(0, fileName.indexOf("."));

    if (fileType === "scenario") {
      targetFileName =
        resultFileName +
        "_" +
        userId +
        "_" +
        intitialValues?.usecase +
        "_" +
        intitialValues?.category +
        "_" +
        intitialValues?.folder +
        "_" +
        intitialValues?.scenario +
        ".xlsx";
      targetFileName =
        intitialValues?.category === 2
          ? "Nut" + targetFileName
          : targetFileName;
    } else if (fileType === "baseline") {
      let scenarioValue = 0;
      targetFileName =
        resultFileName +
        "_" +
        userId +
        "_" +
        intitialValues?.usecase +
        "_" +
        intitialValues?.category +
        "_" +
        intitialValues?.folder +
        "_" +
        scenarioValue +
        ".xlsx";
      targetFileName =
        intitialValues?.category === 2
          ? "Nut" + targetFileName
          : targetFileName;
    } else {
      targetFileName = fileName;
    }
    return targetFileName;
  } else {
    let targetFileName = "";
    let userId = 1;
    const resultFileName = fileName.substring(0, fileName.indexOf("."));

    if (fileType === "scenario") {
      targetFileName =
        resultFileName +
        "_" +
        userId +
        "_" +
        intitialValues?.usecase +
        "_" +
        intitialValues?.category +
        "_" +
        intitialValues?.folder +
        "_" +
        intitialValues?.scenario +
        ".xlsx";
      targetFileName =
        intitialValues?.category === 2
          ? "MtNut" + targetFileName
          : "MtHc" + targetFileName;
    } else if (fileType === "baseline") {
      let scenarioValue = 0;
      targetFileName =
        resultFileName +
        "_" +
        userId +
        "_" +
        intitialValues?.usecase +
        "_" +
        intitialValues?.category +
        "_" +
        intitialValues?.folder +
        "_" +
        scenarioValue +
        ".xlsx";
      targetFileName =
        intitialValues?.category === 2
          ? "MtNut" + targetFileName
          : "MtHc" + targetFileName;
    } else {
      targetFileName = "Mt" + fileName;
    }
    return targetFileName;
  }
};

const resolveFolderName = (
  fileType: number | string,
  v: { usecase: number; category: number },
): string => {
  // Numeric (cog)
  if (typeof fileType === "number") {
    return fileType === 1 ? "ExistingPlants" : "WithoutExistingPlants";
  }

  // String types
  switch (fileType) {
    case "scenario":
      return "Scenario";
    case "baseline":
      return "BaseLine";
    default: {
      // Master
      const isHomecare = v.category === 1;
      const isUsecase1 = v.usecase === 1;
      if (isUsecase1) {
        return isHomecare ? "integrated" : "separated";
      }
      return isHomecare ? "Master_Files/Homecare" : "Master_Files/Nutrition";
    }
  }
};
const normalizeError = (err: any) => {
  let message = "An unexpected error occurred.";
  let details = undefined;
  let status = undefined;

  if (axios.isAxiosError(err)) {
    status = err.response?.status;
    details = err.response?.data;
    // prefer server message/title, otherwise axios message
    message =
      details?.message ||
      details?.title ||
      (typeof details === "string" ? details : undefined) ||
      err.message ||
      message;
    // if validation errors present, join them
    if (details && typeof details === "object") {
      const validation = details?.errors;
      if (validation && typeof validation === "object") {
        try {
          const msgs = Object.values(validation)
            .flat()
            .map((m: any) => (typeof m === "string" ? m : JSON.stringify(m)));
          if (msgs.length) message = msgs.join(" ; ");
        } catch {
          // ignore
        }
      }
    }
  } else if (err instanceof Error) {
    message = err.message;
    details = err;
  } else if (typeof err === "string") {
    message = err;
    details = err;
  } else {
    details = err;
  }

  return { message, details, status };
};
export const onInitUloadMasterFile = (
  formData: any,
  selectedfilesList: any,
  fileType: any,
  intitialValues: any,
  type: string,
  fileModule?: string,
  uploadType?: string | null,
  runType?: string,
  userId?: number,
) => {
  // fileType for short term can be scenario/baseline/master
  // filetype for long term can be 5,9,11,13,15,17 if long term send filemodule in params
  // filetype for medium term can be scenario/baseline/master
  // filetype for cgo can be scenario/baseline/master
  //  type for short term can be uploadnow/rerun
  return async (dispatch: any) => {
    const longTermFileTypes = [5, 9, 11, 13, 15, 17];
    dispatch(uploadMasterFileStart());
    const folderName = resolveFolderName(fileType, intitialValues);
    console.log("folderName", folderName, fileType, intitialValues);
    let isSuccess = false;
    // Prepare params to send to backend
    const baseParams: any = {
      runType: runType,
      folderId: intitialValues.folder,
      scenarioId: intitialValues.scenario,
    };

    const extraParams: any =
      uploadType === "Short Term"
        ? {
            // example short-term specific params (replace with actual API keys)
            category: intitialValues.category === 1 ? "homecare" : "nutrition",
            subcategory: fileType,
            uploadType: "shortterm",
          }
        : uploadType === "Medium Term"
          ? {
              // example short-term specific params (replace with actual API keys)
              category:
                intitialValues.category === 1 ? "homecare" : "nutrition",
              subcategory: fileType,
              uploadType: "mediumterm",
            }
          : uploadType === "longTerm"
            ? {
                uploadType: "longterm",
                fileType: fileModule,
                folderName: fileModule,
              }
            : {
                uploadType: "cog",
                fileType: folderName.toLowerCase(),
                folderName: folderName.toLowerCase(),
              };

    const params = { ...baseParams, ...extraParams };
    const uploadUrl =
      uploadType === "longTerm"
        ? API_BASE_URL + UPLOAD_LONGTERM_SINGLE_FILE_API
        : uploadType === "Short Term"
          ? API_BASE_URL + UPLOAD_SHORTTERM_SINGLE_FILE_API
          : uploadType === "Medium Term"
            ? API_BASE_URL + UPLOAD_MEDIUMTERM_SINGLE_FILE_API
            : API_BASE_URL + UPLOAD_COG_SINGLE_FILE_API;

    const newFormData = new FormData();
    if (
      (uploadType === "longterm" ||
        uploadType === "Short Term" ||
        uploadType === "Medium Term" ||
        uploadType === "COG") &&
      selectedfilesList &&
      selectedfilesList.length
    ) {
      const f = selectedfilesList[0];

      // ensure we have a Blob/File and a mime type fallback for xlsx
      const blobSource =
        f.filedata instanceof Blob ? f.filedata : new Blob([f.filedata]);
      const mime =
        (f.filedata &&
          (f.filedata.type ||
            (f.filedata instanceof Blob && (f.filedata as any).type))) ||
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

      const renamed = new File(
        [blobSource],
        getFileName(fileType, f.filename, intitialValues),
        {
          type: mime,
        },
      );

      newFormData.append("file", renamed);
    } else {
      // For other cases (multi-file), keep the existing array behavior
      selectedfilesList.forEach((f: any) => {
        const renamed = new File(
          [f.filedata],
          typeof fileType === "number"
            ? `${f.filename.replace(".xlsx", "")}_${intitialValues.folder}_${
                intitialValues.scenario
              }.xlsx`
            : getFileName(fileType, f.filename, intitialValues),
          {
            type: f.filedata.type,
          },
        );
        newFormData.append("file", renamed);
      });
    }

    // copy other fields which were added before
    for (const [k, v] of formData.entries()) {
      if (k !== "files") newFormData.append(k, v as any);
    }

    // Send files and params to backend (backend handles SAS token and upload)
    try {
      const response = await axios.post(uploadUrl, newFormData, {
        headers: {
          accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
        params,
      });
      if (response) {
        for (let i = 0; i < selectedfilesList.length; i++) {
          let resultFileName =
            typeof fileType === "number"
              ? `${selectedfilesList[i].filename.replace(".xlsx", "")}_${
                  intitialValues.folder
                }_${intitialValues.scenario}.xlsx`
              : getFileName(
                  fileType,
                  selectedfilesList[i].filename,
                  intitialValues,
                );
          let uploadData =
            typeof fileType === "number"
              ? [
                  {
                    Id: 0,
                    folder_Id: intitialValues?.folder,
                    scenario_Id: Number(intitialValues?.scenario),
                    FileType: fileType,
                    FileName: resultFileName,
                    Status: "Data Processing",
                  },
                ]
              : [
                  {
                    Id: 0,
                    usecaseId: intitialValues?.usecase,
                    category_Id: intitialValues?.category,
                    folder_Id: intitialValues?.folder,
                    scenario_Id: intitialValues?.scenario,
                    FileType:
                      folderName.toLowerCase() === "master_files" ||
                      folderName.toLowerCase() === "master_files/nutrition"
                        ? 1
                        : folderName.toLowerCase() === "baseline"
                          ? 2
                          : 3,
                    FileName: resultFileName,
                    Status: "Data Processing",
                  },
                ];
          isSuccess = true;
          saveUploadFile(dispatch, uploadData);

          // commenting the below because this is also handled from backend now
          // if (typeof fileType === "number" && selectedfilesList.length > 0) {
          //   if (longTermFileTypes.includes(fileType)) {
          //     const urls = API_BASE_URL + LONG_QUESTIONARE_DOWNLOAD_API;
          //     await axios({
          //       url: urls,
          //       method: "post",
          //       headers: { "Content-Type": "application/json;" },
          //       params: {
          //         folder_id: intitialValues?.folder * 1,
          //         scenario_id: Number(intitialValues?.scenario),
          //         fileModule: fileModule,
          //       },
          //       responseType: "arraybuffer",
          //     }).then((response) => {
          //       console.log(response, "Questionnaire Download Response");
          //     });
          //   } else {
          //     const urls = API_BASE_URL + CGO_POTENTIAL_DATA_DOWNLOAD;
          //     await axios({
          //       url: urls,
          //       method: "post",
          //       headers: { "Content-Type": "application/json;" },
          //       data: {
          //         folder_id: intitialValues?.folder,
          //         scenario_id: Number(intitialValues?.scenario),
          //         fileflag: fileType === 1 ? "ep" : "wep",
          //       },
          //       responseType: "arraybuffer",
          //     }).then((response) => {
          //       console.log(response, "CGO Potential Data Download Response");
          //     });
          //   }
          // }
        }
        if (response.status === 200) {
          if (
            typeof fileType !== "number" ||
            fileType === 1 ||
            fileType === 2 ||
            uploadType === "longTerm"
          ) {
            dispatch(uploadMasterFileSuccess(response.data?.message));
          }
        }
      }
    } catch (error) {
      console.error("Upload failed:", error);

      ActivateOrDeactivateFolder(
        intitialValues?.usecase,
        intitialValues?.folder,
        0,
      );
      const payload = normalizeError(error);
      dispatch(openErrorDialog(payload));
      dispatch(uploadMasterFileError(payload));
    }

    if (type === "rerun") dispatch(uploadMasterFileSuccess([]));
  };
};

// const CGOPotententialDataFileDownload = (folderId: any, scenarioId: any) => {};

export const downlLoadTemplatesByTypeMedium = async (
  type: number,
  filename: string,
  categoryId: number,
  usecaseId: number,
) => {
  const urls = API_BASE_URL + DOWNLOAD_TEMPLATE_API_MEDIUM;
  axios({
    url:
      urls +
      "?type=" +
      type +
      "&categoryId=" +
      categoryId +
      "&usecaseId=" +
      usecaseId +
      "&runType=" +
      "newrun" +
      "&folderName=" +
      "integrated",
    method: "post",
    responseType: "arraybuffer",
    headers: { "Content-Type": "application/json;" },
    data: {},
  }).then((response) => {
    console.log(response, "resonseeeee");
    let blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    FileSaver.saveAs(blob, filename);
  });
};

// download remplate for rerun short/medium term
export const downloadRerunTemplate = async (
  usecaseId: number,
  categoryId: number,
  selectedFolderId: number,
  selectedScenarioId: number,
  type: number,
  filename: string,
) => {
  const urls =
    usecaseId === 1 && categoryId === 1
      ? API_BASE_URL + DOWNLOAD_RERUN_ST_HC_TEMPLATE_API
      : usecaseId === 1 && categoryId === 2
        ? API_BASE_URL + DOWNLOAD_RERUN_ST_NT_TEMPLATE_API
        : usecaseId === 2 && categoryId === 1
          ? API_BASE_URL + DOWNLOAD_RERUN_MT_HC_TEMPLATE_API
          : API_BASE_URL + DOWNLOAD_RERUN_MT_NT_TEMPLATE_API;
  axios({
    url:
      urls +
      "?usecaseId=" +
      usecaseId +
      "&category_Id=" +
      categoryId +
      "&folderId=" +
      selectedFolderId +
      "&scenarioId=" +
      selectedScenarioId,
    method: "post",
    responseType: "arraybuffer",
    headers: { "Content-Type": "application/json;" },
    data: {},
  }).then((response) => {
    console.log(response, "resonseeeee");
    let blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    FileSaver.saveAs(blob, filename);
  });
};

export const downlLoadTemplatesByType = async (
  type: number,
  filename: string,
  categoryId: number,
) => {
  const urls = API_BASE_URL + DOWNLOAD_TEMPLATE_API;
  axios({
    url: urls + "?type=" + type + "&categoryId=" + categoryId,
    method: "post",
    responseType: "arraybuffer",
    headers: { "Content-Type": "application/json;" },
    data: {},
  }).then((response) => {
    let blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    FileSaver.saveAs(blob, filename);
  });
};

export const downlLoadCOGTemplatesByType = async (
  type: number,
  fileName: string,
) => {
  const urls = API_BASE_URL + DOWNLOAD_COG_TEMPLATE_API;
  axios({
    url: urls + "?type=" + type,
    method: "post",
    responseType: "arraybuffer",
    headers: { "Content-Type": "application/json;" },
    data: {},
  }).then((response) => {
    let blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    FileSaver.saveAs(blob, fileName);
  });
};

// Download template for the rerun COG
export const downloadCOGTemplateRerun = async (
  folderId: number,
  scenarioId: number,
) => {
  const urls = API_BASE_URL + DOWNLOAD_COG_RERUN_TEMPLATE_API;

  try {
    const response = await axios.post(
      urls,
      { folder_id: folderId, scenario_id: scenarioId }, // <-- send JSON body as curl does
      {
        responseType: "arraybuffer",
        headers: { "Content-Type": "application/json" },
      },
    );

    // If server returned JSON/text (error), decode & log instead of saving
    const contentType = String(
      response.headers?.["content-type"] ||
        response.headers?.["Content-Type"] ||
        ""
    );
    if (
      contentType.includes("application/json") ||
      contentType.includes("text/")
    ) {
      const text = new TextDecoder("utf-8").decode(
        new Uint8Array(response.data),
      );
      console.error("COG rerun download returned error payload:", text);
      return;
    }

    // Basic XLSX/ZIP magic-bytes check: PK\x03\x04
    const arr = new Uint8Array(response.data);
    const isZip =
      arr.length >= 4 &&
      arr[0] === 0x50 &&
      arr[1] === 0x4b &&
      arr[2] === 0x03 &&
      arr[3] === 0x04;
    if (!isZip) {
      console.error("Downloaded payload is not a valid XLSX/ZIP.");
      return;
    }

    // Try to read filename from Content-Disposition, fallback to sensible default
    let filename = `COG_${folderId}_${scenarioId}.xlsx`;
    const disposition =
      response.headers?.["content-disposition"] ||
      response.headers?.["Content-Disposition"];
    if (disposition) {
      const match =
        disposition.match(/filename\*=UTF-8''([^;])/i) ||
        disposition.match(/filename[^;=\n]*=(?:['"])?([^;"'])/i);
      if (match && match[1]) {
        try {
          filename = decodeURIComponent(match[1].replace(/['"]/g, ""));
        } catch {
          filename = match[1].replace(/['"]/g, "");
        }
      }
    }

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    FileSaver.saveAs(blob, filename);
  } catch (err) {
    console.error("downloadCOGTemplateRerun failed:", err);
  }
};

//LT Downloadd Template
export const handleTemplateLTDownLoadByType = async (fileModule: string) => {
  await downlLoadLTTemplatesByType(fileModule);
};

//LT rerun Downloadd Template
export const handleExistingTemplateDownLoad = async (
  folderId: number,
  scenarioId: number,
) => {
  await downloadLTRerunTemplate(folderId, scenarioId);
};

//LT downloadd template
export const downlLoadLTTemplatesByType = async (module: string) => {
  const urls = API_BASE_URL + DOWNLOAD_LT_TEMPLATE + `?fileModule=${module}`;
  const response = await axios({
    url: urls,
    method: "post",
    responseType: "arraybuffer",
    headers: { "Content-Type": "application/json;" },
    data: {},
  });
  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  FileSaver.saveAs(
    blob,
    "LongTerm" + module[0].toUpperCase() + module.slice(1) + "_Template.xlsx",
  );
};

//LT downloadd template
export const downloadLTRerunTemplate = async (
  folderId: number,
  scenarioId: number,
) => {
  const urls = API_BASE_URL + DOWNLOAD_LT_RERUN_TEMPLATE;

  try {
    const response = await axios.post(
      urls,
      { folder_id: folderId, scenario_id: scenarioId }, // <-- send JSON body as curl does
      {
        responseType: "arraybuffer",
        headers: { "Content-Type": "application/json" },
      },
    );

    // If server returned JSON/text (error), decode & log instead of saving
    const contentType = String(
      response.headers?.["content-type"] ||
        response.headers?.["Content-Type"] ||
        ""
    );
    if (
      contentType.includes("application/json") ||
      contentType.includes("text/")
    ) {
      const text = new TextDecoder("utf-8").decode(
        new Uint8Array(response.data),
      );
      console.error("LongTerm rerun download returned error payload:", text);
      return;
    }

    // Basic XLSX/ZIP magic-bytes check: PK\x03\x04
    const arr = new Uint8Array(response.data);
    const isZip =
      arr.length >= 4 &&
      arr[0] === 0x50 &&
      arr[1] === 0x4b &&
      arr[2] === 0x03 &&
      arr[3] === 0x04;
    if (!isZip) {
      console.error("Downloaded payload is not a valid XLSX/ZIP.");
      return;
    }

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    FileSaver.saveAs(
      blob,
      "LongTerm" + folderId + "_" + scenarioId + "_Template.xlsx",
    );
  } catch (err) {
    console.error("downloadCOGTemplateRerun failed:", err);
  }
};

export const handleTemplateDownLoadByType = async (
  type: number,
  filename: string,
  categoryId: number,
) => {
  await downlLoadTemplatesByType(type, filename, categoryId);
};
export const handleTemplateDownLoadByTypeMedium = async (
  type: number,
  filename: string,
  categoryId: number,
  usecaseId: number,
) => {
  await downlLoadTemplatesByTypeMedium(type, filename, categoryId, usecaseId);
};

export const handleRerunTemplateDownload = async (
  usecaseId: number,
  categoryId: number,
  selectedFolderId: number,
  selectedScenarioId: number,
  type: number,
  filename: string,
) => {
  await downloadRerunTemplate(
    usecaseId,
    categoryId,
    selectedFolderId,
    selectedScenarioId,
    type,
    filename,
  );
};

export const handleTemplateCOGDownLoadByType = async (
  type: number,
  fileName: string,
) => {
  await downlLoadCOGTemplatesByType(type, fileName);
};

export const COGTemplateDownload = async (
  folderId: number,
  scenarioId: number,
) => {
  await downloadCOGTemplateRerun(folderId, scenarioId);
};

//Input folder name
export const inputFolderValue = (data: any) => ({
  type: INPUT_FOLDER_NAME,
  data,
});

//Select Input folder
export const inputUploadFolderId = (data: any) => ({
  type: SELECTED_UPLOAD_FOLDER_ID,
  data,
});

//Select Input scenario
export const inputUploadScenarioId = (data: any) => ({
  type: SELECTED_UPLOAD_SCENARIO_ID,
  data,
});

//Upload base line
export const uploadBaseLineStart = () => ({
  type: UPLOAD_BASE_LINE_START,
});

export const uploadBaseLineSuccess = (data: any) => ({
  type: UPLOAD_BASE_LINE_SUCCESS,
  data,
});

export const uploadBaseLineError = (error: any) => ({
  type: UPLOAD_BASE_LINE_ERROR,
  error,
});

export const baseLineUploader = () => ({
  type: BASE_LINE_UPLOADER,
});

export const onInitBaseLineUpload = (files: any, folderName: any) => {
  return (dispatch: any) => {
    dispatch(uploadBaseLineStart());
    const urls = API_BASE_URL + BASE_FILE_UPLOAD_API;
    const createScenario = API_BASE_URL + CREATE_NEW_SCENARIO_API;

    const header_default = {
      accept: "application/json",
      "Content-Type": "application/json",
    };

    const header = {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    };

    postRequest(
      createScenario,
      {
        folder: folderName,
        time:
          new Date().getFullYear() +
          "-" +
          new Date().getMonth() +
          "-" +
          new Date().getDate(),
        scenario: "base",
        number: "99",
      },
      header_default,
      {},
    ).then((resp) => {
      postRequest(urls, files, header, {
        folder: folderName,
        type: "base",
        scenario: "base",
        number: "99",
      })
        .then((response) => {
          if (response.status === 200) {
            dispatch(uploadBaseLineSuccess(response.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(uploadBaseLineError(error));
        });
    });
  };
};

//Create new folder
export const createNewFolderStart = () => ({
  type: CREATE_NEW_FOLDER_START,
});

export const createNewFolderSuccess = (data: any) => ({
  type: CREATE_NEW_FOLDER_SUCCESS,
  data,
});

export const createNewFolderError = (error: any) => ({
  type: CREATE_NEW_FOLDER_ERROR,
  error,
});

export const onInitCreateNewFolder = (data: any) => {
  return (dispatch: any) => {
    dispatch(createNewFolderStart());
    const urls = API_BASE_URL + CREATE_NEW_FOLDER_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, data, header, {})
      .then((response) => {
        // getRequest(urls, data, header).then((response) => {
        if (response.data.success === true) {
          //set folder Id
          dispatch(createNewFolderSuccess(response.data?.data));

          dispatch(isFolderExisted(false));
        } else {
          //dispatch(openErrorDialog("Folder is existed"));
          dispatch(isFolderExisted(true));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(createNewFolderError(error));
      });
  };
};

//Create new Scenario
export const createNewScenarioStart = () => ({
  type: CREATE_NEW_SCENARIO_START,
});

export const createNewScenarioSuccess = (data: any) => ({
  type: CREATE_NEW_SCENARIO_SUCCESS,
  data,
});

export const createNewScenarioError = (error: any) => ({
  type: CREATE_NEW_SCENARIO_ERROR,
  error,
});

export const onInitcreateNewScenario = (data: any) => {
  return (dispatch: any) => {
    dispatch(createNewScenarioStart());
    const urls = API_BASE_URL + CREATE_NEW_SCENARIO_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, data, header, {})
      .then((response) => {
        if (response.status === 200 && response.data.success === true) {
          dispatch(isScenarioExisted(false));
          dispatch(createNewScenarioSuccess(response.data?.data));
        } else {
          dispatch(isScenarioExisted(true));
        }
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(createNewScenarioError(error));
      });
  };
};

//Upload Scenario line
export const ScenarioLineUploadStart = () => ({
  type: UPLOAD_SCENARIO_LINE_START,
});

export const ScenarioLineUploadSuccess = (data: any) => ({
  type: UPLOAD_SCENARIO_LINE_SUCCESS,
  data,
});

export const ScenarioLineUploadError = (error: any) => ({
  type: UPLOAD_SCENARIO_LINE_ERROR,
  error,
});

export const onInitScenarioLineUpload = (data: any, scenarioData: any) => {
  return (dispatch: any) => {
    dispatch(ScenarioLineUploadStart());
    const urls = API_BASE_URL + BASE_FILE_UPLOAD_API;
    const header = {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    };

    postRequest(urls, data, header, {
      folder: scenarioData?.folder,
      scenario: scenarioData?.scenario,
      type: scenarioData?.type,
      number: scenarioData?.number,
    })
      .then((response: any) => {
        if (
          response.status === 200 ||
          response?.message?.indexOf("Successfuly uploaded") >= 0
        ) {
          //  dispatch(ScenarioLineUploadSuccess(response.data));
        }
        dispatch(ScenarioLineUploadSuccess(response.data));
      })
      .catch((error) => {
        dispatch(openErrorDialog(error));
        dispatch(ScenarioLineUploadError(error));
      });
  };
};

export const loadFactoryOptions = (data: any) => {
  const factoryOptions: any = [];
  data.map((item: any) => {
    const filteredItem = factoryOptions.find((obj: any) => {
      return obj.factory_Name === item.factory;
    });
    if (filteredItem === undefined || filteredItem == null) {
      factoryOptions.push({ id: item.id, factory_Name: item.factory });
    }
  });

  return factoryOptions;
  //setFactoryOptions(factoryOptions);
};

export const loadCascadeOptions = (data: any) => {
  const cascadeOptions: any = [];
  data.map((item: any) => {
    const filteredItem = cascadeOptions.find((obj: any) => {
      return obj.cascade === item.cascade;
    });
    if (filteredItem === undefined || filteredItem == null) {
      cascadeOptions.push({ id: item.id, cascade: item.cascade });
    }
  });
  //setLineOptions(lineOptions);
  return cascadeOptions;
};

export const loadProductOptions = (data: any) => {
  const productOptions: any = [];
  data.map((item: any) => {
    const filteredItem = productOptions.find((obj: any) => {
      return obj.product === item.product;
    });
    if (filteredItem === undefined || filteredItem == null) {
      productOptions.push({ id: item.id, product: item.product });
    }
  });
  //setLineOptions(lineOptions);
  return productOptions;
};

export const loadLineOptions = (data: any) => {
  const lineOptions: any = [];
  data.map((item: any) => {
    const filteredItem = lineOptions.find((obj: any) => {
      return obj.line === item.line;
    });
    if (filteredItem === undefined || filteredItem == null) {
      lineOptions.push({ id: item.id, line: item.line });
    }
  });
  return lineOptions;
};

export const loadBasePackOptions = (data: any) => {
  const basePackOptions: any = [];
  data.map((item: any) => {
    const filteredItem = basePackOptions.find((obj: any) => {
      return obj.basepack === item.basepack;
    });
    if (filteredItem === undefined || filteredItem == null) {
      basePackOptions.push({ id: item.id, basepack: item.basepack });
    }
  });
  //setBasepackOptions(basePackOptions);
  return basePackOptions;
};

export const loadTimePeriodOptions = (data: any) => {
  const timePeriodPackOptions: any = [];
  data.map((item: any) => {
    const filteredItem = timePeriodPackOptions.find((obj: any) => {
      return obj.time_Period === item.time_period;
    });
    if (filteredItem === undefined || filteredItem == null) {
      timePeriodPackOptions.push({
        id: item.id,
        time_Period: item.time_period,
      });
    }
  });
  return timePeriodPackOptions;
  //setTimePeriodOptions(timePeriodPackOptions);
};

export const loadCapacityOptions = (data: any) => {
  const capacityOptions: any = [];
  data.map((item: any) => {
    const filteredItem = capacityOptions.find((obj: any) => {
      return obj.capacity === item.capacity;
    });
    if (filteredItem === undefined || filteredItem == null) {
      capacityOptions.push({ id: item.id, capacity: item.capacity });
    }
  });
  return capacityOptions;
  //setTimePeriodOptions(timePeriodPackOptions);
};

// Display Product Table Data
export const ViewProductTableStart = () => ({
  type: VIEW_PRODUCT_TABLE,
});

export const ViewProductTableSuccess = (data: any) => ({
  type: VIEW_PRODUCT_TABLE_SUCCESS,
  data,
});

export const ViewProductTableError = (error: any) => ({
  type: VIEW_PRODUCT_TABLE_ERROR,
  error,
});

// Edit Product Table Data
export const EditProductTableStart = () => ({
  type: EDIT_PRODUCT_TABLE,
});

export const EditProductTableSuccess = (data: any) => ({
  type: EDIT_PRODUCT_TABLE_SUCCESS,
  data,
});

export const EditProductTableError = (error: any) => ({
  type: EDIT_PRODUCT_TABLE_ERROR,
  error,
});

//Display List of folder
export const displayFolderList = () => ({
  type: DISPLAY_FOLDER_LIST,
});

export const displayFolderListSuccess = (data: any) => ({
  type: DISPLAY_FOLDER_LIST_SUCCESS,
  data,
});

export const displayFolderListError = (error: any) => ({
  type: DISPLAY_FOLDER_LIST_ERROR,
  error,
});

export const setApiUserData = (data: any) => ({
  type: API_USER_DATA,
  data,
});

// Selected folder list
export const selectedFolderList = () => ({
  type: SELECTED_FOLDER_LIST,
});

export const selectedFolderListSuccess = (data: any) => ({
  type: SELECTED_FOLDER_LIST_SUCCESS,
  data,
});

export const selectedUploadFolderListSuccess = (data: any) => ({
  type: SELECTED_UPLOAD_FOLDER_LIST_SUCCESS,
  data,
});

export const selectedFolderListError = (error: any) => ({
  type: SELECTED_FOLDER_LIST_ERROR,
  error,
});

//Display List of Scenario
export const displayScenarioList = () => ({
  type: DISPLAY_SCENARIO_LIST,
});

export const displayScenarioListSuccess = (data: any) => ({
  type: DISPLAY_SCENARIO_LIST_SUCCESS,
  data,
});

export const displayMonthNamesListSuccess = (data: any) => ({
  type: DISPLAY_SCENARIO_LIST_SUCCESS,
  data,
});

export const displayScenarioListError = (error: any) => ({
  type: DISPLAY_SCENARIO_LIST_ERROR,
  error,
});

// Selected Scenario list
export const selectedScenarioList = () => ({
  type: SELECTED_SCENARIO_LIST,
});

export const selectedScenarioListSuccess = (data: any) => ({
  type: SELECTED_SCENARIO_LIST_SUCCESS,
  data,
});

export const selectedTimePeriodSuccess = (data: any) => ({
  type: SELECTED_TIME_PERIOD_LIST,
  data,
});
export const selectedScenarioListError = (error: any) => ({
  type: SELECTED_SCENARIO_LIST_ERROR,
  error,
});

//Selected Category list
// export const selectedUsecaseList = () => ({
//   type: SELECTED_USECASE_LIST
// });

export const selectedUsecaseListSuccess = (data: any) => ({
  type: SELECTED_USECASE_LIST_SUCCESS,
  data,
});

export const selectedUsecaseListError = (error: any) => ({
  type: SELECTED_USECASE_LIST_ERROR,
  error,
});

//Selected Category list
// export const selectedCategoryList = () => ({
//   type: SELECTED_CATEGORY_LIST
// });

export const selectedCategoryListSuccess = (data: any) => ({
  type: SELECTED_CATEGORY_LIST_SUCCESS,
  data,
});

export const selectedCategoryListError = (error: any) => ({
  type: SELECTED_CATEGORY_LIST_ERROR,
  error,
});

// Display Dashboard Summary Cost
export const displayDashboardSummaryCost = () => ({
  type: DASHBOARD_SUMMARY_COST,
});

export const displayDashboardSummaryCostSuccess = (data: any) => ({
  type: DASHBOARD_SUMMARY_COST_SUCCESS,
  data,
});

export const displayDashboardSummaryCostError = (error: any) => ({
  type: DASHBOARD_SUMMARY_COST_ERROR,
  error,
});

// Display Nutrition Summary Cost

export const nutritionDisplayDashboardSummaryCost = () => ({
  type: NUTRITION_DASHBOARD_SUMMARY_COST,
});

export const nutritionDisplayDashboardSummaryCostSuccess = (data: any) => ({
  type: NUTRITION_DASHBOARD_SUMMARY_COST_SUCCESS,
  data,
});

export const nutritionDisplayDashboardSummaryCostError = (error: any) => ({
  type: NUTRITION_DASHBOARD_SUMMARY_COST_ERROR,
  error,
});
export const enableEditFilter = (data: boolean, type: string) => {
  if (type === "handleedit") {
    return {
      type: ENABLE_EDIT,
      data: true,
    };
  } else {
    return {
      type: DISABLE_EDIT,
      data: false,
    };
  }
};
export const fileUploadStatus = (data: any) => ({
  type: FILE_UPLOAD_STATUS,
  data,
});

export const enableEditPopupForSave = (data: any) => ({
  type: EDIT_SCENARIO_POPUP_FLAG,
  data,
});

export const addProcessingPackagingPlantsDiff = (data: any) => ({
  type: SET_PROCESSING_PACKAGING_PL,
  data,
});

export const addSourceBePartOfOptimization = (data: any) => ({
  type: SET_SOURCE_BE_PART_OF_OPTIMIZATION,
  data,
});

export const addPackingPlantAddMinorIngredient = (data: any) => ({
  type: SET_PROCESSING_PACKAGING_PLANT_ADD_MINOR,
  data,
});

export const loginUserDetails = (data: any) => ({
  type: LOGIN_USER_DATA,
  data,
});
